function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createMessage } from "../core/createMessage.mjs";
import { isWebView } from "../core/isWebView.mjs";
import { Type } from "../protocol/Type.mjs";
import { PluginBase } from "./Base.mjs";
export class PluginShare extends PluginBase {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "namespace", 'share');
  }

  open({
    url,
    text
  }) {
    if (!isWebView()) {
      return this.logger.log('WARN', 'bridge.share.open', 'WebView 환경이 아닌 환경에서는 해당 함수를 지원하지 않아요');
    }

    this.driver.postMessage(createMessage({
      type: Type.ReqShareOpen,
      payload: {
        share: {
          url,
          text
        }
      }
    }));
  }

}